import { render, staticRenderFns } from "./Endnotenuebersicht.vue?vue&type=template&id=60ac3a73&scoped=true"
import script from "./Endnotenuebersicht.vue?vue&type=script&lang=js"
export * from "./Endnotenuebersicht.vue?vue&type=script&lang=js"
import style0 from "./Endnotenuebersicht.vue?vue&type=style&index=0&id=60ac3a73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ac3a73",
  null
  
)

export default component.exports